// extracted by mini-css-extract-plugin
export default {"product":"XU","image_carousel":"YU","main_gallery":"ZU","personalized_badge":"aV","greens_badge":"bV","arrows":"cV","slide":"eV","thumbnail_gallery":"fV","swiper-slide":"gV","learn_more":"hV","product_info":"iV","description_wrapper":"jV","checklist":"kV","checklistItem":"lV","delivery_freq":"mV","tooltip_button":"nV","key_benefits":"oV","benefit_item":"pV","ingredients":"qV","ingredient_item":"rV","active_slide":"sV","benefits_list":"tV","checkmark":"uV"};
    if(module.hot) {
      // 1713211525427
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  